<template>
  <div class="main-wrapper">
    <div class="features-section">
      <button @click="onBackClick" class="back-btn" v-t="'mobilePayment.back'" />
      <h1 v-t="'mobilePayment.title'" class="payment-header" />
      <div class="features-wrapper">
        <ul class="features">
          <li
            :key="idx"
            v-for="(_, idx) in $t(`mobilePayment.features:${os}`)"
            v-html="$t(`mobilePayment.features:${os}.${idx}`)"
            class="feature"
          />
        </ul>
      </div>
    </div>
    <div id="notice-section" class="notice-section" v-if="os === 'ios'">
      <div class="notice-wrapper">
        <p
          :key="notice_token"
          v-for="notice_token in $t('mobilePayment.notice')"
          v-html="$t(notice_token)"
          class="notice-paragraph"
        />
      </div>
    </div>
    <div class="btn-section">
      <base-button
        @click.native="onHandlePayment"
        v-t="`mobilePayment.try free:${os}`"
        :small="true"
      />
      <div class="btn-subtitle" v-html="$t('mobilePayment.btn-subtitle')" v-if="os === 'android'" />
      <a
        href="#notice-section"
        class="btn-subtitle-link"
        v-if="os === 'ios'"
        v-text="$t('mobilePayment.btn-subtitle-link')"
      />
    </div>
  </div>
</template>

<script>
import * as Sentry from '@sentry/browser';
import store from '@/store';
import { sitePrepareRequestIAP } from '@/services/sitePrepareRequestIAP';

export default {
  methods: {
    onBackClick() {
      this.$router.push('/preview');
    },
    onHandlePayment() {
      try {
        window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'payment' }));
        window.addEventListener('purchase-go-to-publish-page', this.handleGoToPublishPage);
        this.rnAppMetricaReportEvent('try_it_free', store.appMetricaData);
        Sentry.captureMessage('successufuly send payment event to webview');
      } catch (error) {
        Sentry.captureException(error);
      }
    },
    async handleGoToPublishPage({ detail }) {
      store.assign({ paymentStatus: 'success' }).saveToLS();
      await sitePrepareRequestIAP({
        jwt: store.jwt,
        data: {
          purchaseData: detail,
          email: store.wizard.email,
          publishedSiteDomain: store.publishedSiteDomain,
          constructorDomain: store.constructorDomain,
        },
      });
      this.$router.push('/publishing');
    },
  },
  computed: {
    os() {
      return window.REACT_NATIVE_WEBVIEW_OS || 'android';
    },
    trial() {
      return this.$t(`mobilePayment.trial:${this.os}`);
    },
  },
};
</script>

<style scoped src="./mobilePayment.css"></style>
